import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {GroundSlot} from "@/modules/club-grounds/entity";
import {EvaluateDayEvent} from "@/modules/season/events/EvaluateDayEvent";
import SlotUnlocker from "@/modules/club-grounds/services/SlotUnlocker";
import SlotDemolisher from "@/modules/club-grounds/services/SlotDemolisher";
import SlotDeveloper from "@/modules/club-grounds/services/SlotDeveloper";

@injectable()
export class GroundSlotEventSubscriber implements EventSubscriber {
  constructor(
    @inject(SlotUnlocker) private slotUnlocker: SlotUnlocker,
    @inject(SlotDemolisher) private slotDemolisher: SlotDemolisher,
    @inject(SlotDeveloper) private slotBuilder: SlotDeveloper,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: EvaluateDayEvent, callback: this.onEvaluateDayEvent},
    ];
  }

  async onEvaluateDayEvent(event: EvaluateDayEvent): Promise<void> {
    const slots = await GroundSlot
      .createQueryBuilder('slot')
      .getMany();

    await slots
      .filter(s => s.availableAt && s.availableAt <= event.season.currentDateRaw)
      .forEachAsync<GroundSlot>((slot: GroundSlot) => this.slotUnlocker.finish(slot));

    await slots
      .filter(s => s.demolishAt && s.demolishAt <= event.season.currentDateRaw)
      .forEachAsync<GroundSlot>((slot: GroundSlot) => this.slotDemolisher.finish(slot));

    await slots
      .filter(s => s.developedAt && s.developedAt <= event.season.currentDateRaw)
      .forEachAsync<GroundSlot>((slot: GroundSlot) => this.slotBuilder.finish(slot));
  }
}